import React, { useState } from 'react';

// Notes: A component that using input with an "Add" button
// to add the input value to a list
// that showing at the bottom of the input.
export const AddTextItemInput = ({
	onAdd,
	placeholder,
	list = [],
	maxItems,
	inputStyle = {},
}) => {
	const [text, setText] = useState("");
	const onChange = (e) => {
		setText(e.target.value);
	}
	const onAddItem = () => {
		onAdd(text);
		setText("");
	}

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' && text) {
			onAddItem();
		}
	}

	const isLimitReached = maxItems !== undefined && list.length >= maxItems;

	return (
		<div className="add-item">
			<input type="text" name="items" value={text} onChange={onChange} onKeyDown={handleKeyDown} placeholder={placeholder} disabled={isLimitReached} style={inputStyle} />
			<button className="btn-outline" type="button" disabled={text ? false : true || isLimitReached} onClick={onAddItem}>{I("Add")}</button>
			{isLimitReached && (
				<div className="intent-limit-msg" style={{ color: '#c00', fontSize: '12px', marginTop: '4px' }}>
					{I(`Maximum ${maxItems} items allowed.`)}
				</div>
			)}
		</div>
	)
}

export const AddTextItemInputContainer = ({
	id,
	onAdd,
	onRemove,
	placeholder,
	list = [],
	vertical = false,
	maxItems,
	style = {},
	inputStyle = {},
}) => {
	const onAddItem = (text) => {
		if (list.indexOf(text) > -1) {
			console.log("Error: text already in list");
			return;
		}
		onAdd(id, text);
	}
	const onRemoveItem = (index) => {
		onRemove(id, index);
	}

	return (
		<div id={"AddTextItemInputContainer_"+id} className={"add-item-container" + (vertical ? " vertical" : "") } style={style}>
			<AddTextItemInput onAdd={onAddItem} onRemove={onRemoveItem} placeholder={placeholder} list={list} maxItems={maxItems} inputStyle={inputStyle} />
			<div className={"added-list" + (vertical ? " vertical" : "") } style={vertical ? { display: 'flex', flexDirection: 'column', gap: '4px' } : {}}>
				{list.map((item, index) => {
					return (
						<div key={index} className={"added-item" + (vertical ? " vertical" : "") } style={vertical ? { width: '90%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' } : {}}>
							<span>{item}</span>
							<i className="icon-times" style={vertical ? { marginLeft: 8, cursor: 'pointer' } : {}} onClick={() => onRemoveItem(index)}></i>
						</div>
					)
				})}
			</div>
		</div>
	)
}
